import {register} from 'register-service-worker';
import {Notify} from 'quasar';

// The ready(), registered(), cached(), updatefound() and updated()
// events passes a ServiceWorkerRegistration instance in their arguments.
// ServiceWorkerRegistration: https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerRegistration

register(process.env.SERVICE_WORKER_FILE, {
  // The registrationOptions object will be passed as the second argument
  // to ServiceWorkerContainer.register()
  // https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerContainer/register#Parameter

  // registrationOptions: { scope: './' },

  ready() {
    if (process.env.DEV) {
      console.log('App is being served from cache by a service worker.');
    }
  },

  registered(/* registration */) {
    if (process.env.DEV) {
      console.log('Service worker has been registered.');
    }
  },

  cached(/* registration */) {
    if (process.env.DEV) {
      console.log('Content has been cached for offline use.');
    }
  },

  updatefound(registration) {
    if (process.env.DEV) {
      console.log('New content is downloading.');
    }

    if (registration.active !== null) {
      location.replace('#/update');
    }
  },

  updated(/* registration */) {
    if (process.env.DEV) {
      console.log('New content is available; please refresh !');
    }

    Notify.create({
      color: "positive",
      message: "L'application a été mise à jour !",
      timeout: 5000
    })

    const lastVisitedUri = '/home';
    if (sessionStorage.getItem('lastVisitedUri') !== '/') {
      this.lastVisitedUri = sessionStorage.getItem('lastVisitedUri');
    }
    if (lastVisitedUri.startsWith('/#')) {
      location.replace(lastVisitedUri);
    }
    else {
      location.replace('/#' + lastVisitedUri);
    }
  },

  offline() {
    if (process.env.DEV) {
      console.log('No internet connection found. App is running in offline mode.');
    }

    Notify.create({
      message:
        'Tokatab ne fonctionne pas en mode hors ligne pour le moment !',
      icon: 'mdi-cloud-alert',
      closeBtn: 'Ok',
      timeout: 5000,
    });
  },

  error(err) {
    if (process.env.DEV) {
      console.error('Error during service worker registration:', err);
    }
  },
});
